import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import { useFormik } from 'formik';
import * as yup from "yup";
import { useToken } from '../components/TokenProvider';
import { useUser } from '../components/UserContext';
import TabTitle from '../components/TabTitle';
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';
// import { useDispatch } from 'react-redux';
// import { fetchUsers } from '../redux/actions';

export default function AdminSignup() {
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { setToken } = useToken(); // Access the token from context
    const { setUser } = useUser();

    const validationSchema = yup.object({
        email: yup
            .string("Enter email address")
            .email("Enter a valid email")
            .required("Email address is required"),
        first_name: yup
            .string("Enter first name")
            .min(1, "First name is required")
            .max(100, "First name is too long")
            .required("First name is required"),
        last_name: yup
            .string("Enter last name")
            .min(1, "Last name is required")
            .max(100, "Last name is too long")
            .required("Last name is required"),
        password: yup
            .string("Enter password")
            .min(8, "Password must be at least 8 characters")
            .max(12, "Password must be at most 12 characters")
            .required("Password is required"),
        company_name: yup
            .string("Enter company name")
            .min(1, "Company name is required")
            .max(100, "Company name is too long")
            .required("Company name is required"),
        company_description: yup
            .string("Enter company description")
            .min(1, "Company description is required")
            .max(200, "Company description is too long")
            .required("Company description is required"),
    });

    const formik = useFormik({
        initialValues: {
            email: "",
            first_name: "",
            last_name: "",
            password: "",
            company_name: "",
            company_description: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                setIsSubmitting(true);
                setMessage('');
                const response = await api.post('/assessment/admin_signup/', values);
                setMessage("Signup successful! Please login.");
                setIsSubmitting(false);
                setTimeout(() => {
                    navigate('/emailVerify', { state: { email: values.email } });
                }, 1500);
            } catch (error) {
                setIsSubmitting(false);
                setMessage(error.response?.data?.message || 'An error occurred. Please try again.');
            }
        }
    });

    return (
        <div>
            <TabTitle title="Admin Signup" />
            <div className="d-flex justify-content-center align-items-center full-height-background">
                <div className="col-10 p-sm-8 col-md-5 col-lg-5 col-xl-4" style={{ opacity: "0.85" }}>
                    <div className="card p-4 p-md-5 p-sm-3 my-4">
                        <form className='signup-form' onSubmit={formik.handleSubmit}>
                            <h2 className='mb-4 mb-sm-5 text-center fw-bold'>Admin Signup</h2>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email<span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className="form-control forminput-custom"
                                    id="email"
                                    name="email"
                                    placeholder="name@example.com"
                                    value={formik.values.email}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    required
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <small className="form-text text-danger">{formik.errors.email}</small>
                                )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="first_name" className="form-label">First Name<span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control forminput-custom"
                                    id="first_name"
                                    name="first_name"
                                    value={formik.values.first_name}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    required
                                />
                                {formik.touched.first_name && formik.errors.first_name && (
                                    <small className="form-text text-danger">{formik.errors.first_name}</small>
                                )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="last_name" className="form-label">Last Name<span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control forminput-custom"
                                    id="last_name"
                                    name="last_name"
                                    value={formik.values.last_name}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    required
                                />
                                {formik.touched.last_name && formik.errors.last_name && (
                                    <small className="form-text text-danger">{formik.errors.last_name}</small>
                                )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Password<span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="form-control forminput-custom"
                                        id="password"
                                        name="password"
                                        value={formik.values.password}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        required
                                    />
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{ width: '50px', height: '38px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                    >
                                        {showPassword ? (
                                            <EyeFill color="#000" />
                                        ) : (
                                            <EyeSlashFill color="#000" />
                                        )}
                                    </button>
                                </div>
                                    {formik.touched.password && formik.errors.password && (
                                        <small className="form-text text-danger">{formik.errors.password}</small>
                                    )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="company_name" className="form-label">Company Name<span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control forminput-custom"
                                    id="company_name"
                                    name="company_name"
                                    value={formik.values.company_name}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    required
                                />
                                {formik.touched.company_name && formik.errors.company_name && (
                                    <small className="form-text text-danger">{formik.errors.company_name}</small>
                                )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="company_description" className="form-label">Company Description<span className="text-danger">*</span></label>
                                <textarea
                                    className="form-control forminput-custom"
                                    id="company_description"
                                    name="company_description"
                                    value={formik.values.company_description}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    required
                                    rows={3}
                                />
                                {formik.touched.company_description && formik.errors.company_description && (
                                    <small className="form-text text-danger">{formik.errors.company_description}</small>
                                )}
                            </div>
                            <div className="d-grid">
                                <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            <span className="sr-only">Submitting...</span>
                                        </>
                                    ) : "Sign Up"}
                                </button>
                            </div>
                        </form>
                        {message && <div className="mt-3 alert alert-info">{message}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
}